module.exports = __webpack_public_path__ + "static/media/PSLxText.c5467766.ttf";